import { useEventListener } from "usehooks-ts";

type KeyPressListener = (key: string, onPress?: () => void) => void;

const useKeyPressListener: KeyPressListener = (key, onPress) => {
  useEventListener("keydown", (e) => {
    if (e.key === key && onPress) {
      onPress();
    }
  });
};

export { useKeyPressListener };
